import { useLocation } from "react-router";
import { HostOverlayBar } from "@/components/hosts/HostOverlayBar";
import type { GlobalHostBarProps } from "@/components/Header";
import { usePreviewedHostId } from "@/hooks/use-previewed-client-id";
import { routePaths } from "@/lib/app-navigation";

export function GlobalHostBar({
  projectId,
  onEditHost,
  onCanvasReplaceHost,
}: GlobalHostBarProps) {
  const location = useLocation();
  const [previewedHostId, setPreviewedHostId] = usePreviewedHostId(projectId);

  // While the Connect host canvas is open, the client selector lives in the
  // canvas's own nav row (`HostCanvasSelector`, beside Servers|Client) — hide
  // the header instance so the control isn't duplicated. Mirrors HostsTab's
  // open-canvas condition:
  // on the hosts route with either a URL host id or a previewed fallback.
  const onHostsRoute =
    location.pathname === routePaths.clients ||
    location.pathname.startsWith(`${routePaths.clients}/`);
  const urlHostId = onHostsRoute
    ? (location.pathname
        .slice(`${routePaths.clients}/`.length)
        .split("/")[0] || null)
    : null;
  if (onHostsRoute && (urlHostId || previewedHostId)) {
    return null;
  }

  return (
    <HostOverlayBar
      projectId={projectId}
      previewedHostId={previewedHostId}
      onChangePreviewedHostId={setPreviewedHostId}
      onEditHost={onEditHost}
      onCanvasReplaceHost={onCanvasReplaceHost}
    />
  );
}
